/**
 *
 * This function takes a react node and a context object and returns the node wrapped by the context consumer
 */

import React from "react"

const consumeContext = (InnerConsumer, contextApi) => {
  if (!contextApi) {
    return InnerConsumer
  }

  const key = Object.keys(contextApi)[0]
  const Context = Object.values(contextApi)[0]

  return React.forwardRef(({contextAccumulator: parentContext = {}, ...ownProps}, ref) => (
    <Context.Consumer>
      {(context) => (
        <InnerConsumer
          {...ownProps}
          contextAccumulator={{...parentContext, [key]: context}}
          ref={ref} />
      )}
    </Context.Consumer>
  ))
}
export default consumeContext
